import React, { useState, Fragment, useEffect } from "react";

import { Link } from "react-router-dom";

import { Grid } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import billieeilish from "../../assets/images/billieeilish.jpg";
// import tophits from "../../assets/images/tophits.jpg";
import CardArt from "../cards/CardArt";
import { v4 as uuidv4 } from "uuid";

import { fetch } from "whatwg-fetch";

const SearchBar = ({
  setSelected,
  placeholder,
  context,
  searchType,
  action,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchLoading, setSearchLoading] = useState(true);
  const [searchResults, setSearchResults] = useState([]);
  const searchTypeParam = searchType || "alas";

  const showSearch = () => {
    if (searchTerm.length > 1) {
      setSelected(true);
      //   doQuery(searchTerm);
    } else {
      hideSearch();
    }
  };

  useEffect(() => {
    if (searchTerm.length > 1) {
      setSelected(true);
      doQuery(searchTerm);
    } else {
      hideSearch();
    }
  }, [searchTerm]);

  useEffect(() => {
    const el = document.querySelector(".search-result:first-child");
    el?.classList.add("selected");
  }, [searchResults]);

  const clearSearch = () => {
    setSearchTerm("");
    hideSearch();
  };

  const hideSearch = () => {
    setSelected(false);
  };

  let text;
  if (placeholder) {
    text = placeholder;
  } else {
    text = "Artist or Genre";
  }

  const handleKeyDown = (e) => {
    switch (e.which) {
      case 40: // down
        e.preventDefault(); // prevent moving the cursor
        let el = document.querySelector(
          ".search-result:not(:last-child).selected"
        );
        if (!el) {
          return;
        }
        el.classList.remove("selected");
        el.nextElementSibling.classList.add("selected");
        break;
      case 38: // up
        e.preventDefault();

        let pel = document.querySelector(
          ".search-result:not(:first-child).selected"
        );
        if (!pel) {
          return;
        }

        pel.classList.remove("selected");
        pel.previousElementSibling.classList.add("selected");
        break;
      case 13: // enter
        e.preventDefault();
        let sel = document.querySelector(".search-result.selected a");
        if (!sel) {
          return;
        }
        sel.click();
        clearSearch();
        break;
    }
  };

  let cache = {};

  const doQuery = (value) => {
    const cachedResult = cache[value];
    if (cachedResult) {
      setSearchLoading(false);
      return cachedResult;
    }

    setSearchLoading(true);

    fetch(
      `/artists/jsearch.json?${new URLSearchParams({
        query: value,
        search_type: searchTypeParam,
      })}`,
      { method: "GET", mode: "cors" }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("data:", data);
        cache[value] = data;
        setSearchLoading(false);
        setSearchResults(data);
      })
      .catch((error) => {
        console.error("Request Failed: " + error);
        setSearchLoading(false);
        setSearchResults([]);
      });

    // $.getJSON("/artists/jsearch", {
    //   query: value,
    //   search_type: "alas",
    // })
    //   .done((data, status, xhr) => {
    //     console.log(data, status, xhr);
    //     console.log("data:", data);
    //     cache[value] = data;
    //     setSearchLoading(false);
    //     setSearchResults(data);
    //   })
    //   .fail((jqxhr, textStatus, error) => {
    //     var err = textStatus + ", " + error;
    //     console.log("Request Failed: " + err);
    //     setSearchLoading(false);
    //     setSearchResults({});
    //   });
  };

  return (
    <div className="searchbar-container">
      <div className="search-close icon-action" onClick={clearSearch}>
        <FontAwesomeIcon icon="times" />
      </div>
      <div className="searchbar">
        <Grid container spacing={0} alignItems="center">
          <Grid item xs>
            <input
              placeholder={text}
              value={searchTerm}
              onChange={(evt) => {
                console.log("search value: ", evt.target.value);
                setSearchTerm(evt.target.value);
                // showSearch();
              }}
              onKeyDown={handleKeyDown}
              onFocus={showSearch}
            />
          </Grid>
          <Grid item className="text-right pr-2">
            <FontAwesomeIcon icon="search" className="icon-action" />
          </Grid>
        </Grid>
      </div>
      <div className="search-results">
        <div className="inner" onClick={hideSearch}>
          {searchLoading ? (
            "Loading..."
          ) : (
            <Fragment>
              {Object.keys(searchResults).length == 0 && <div>None found</div>}

              {searchResults?.artists?.results?.length > 0 &&
                searchResults.artists.results.map(
                  ({ title, url, station_id, image, artist_id }) => {
                    return (
                      <SearchResult
                        action={action}
                        context={context}
                        key={uuidv4()}
                        type="" // "Artist"
                        name={title}
                        image={image}
                        url={url}
                        artist_id={artist_id}
                        station_id={station_id}
                      />
                    );
                  }
                )}

              {searchResults?.genres?.results?.length > 0 &&
                searchResults.genres.results.map(
                  ({ title, url, station_id, image }) => {
                    return (
                      <SearchResult
                        context={context}
                        key={uuidv4()}
                        type="Genre"
                        name={title}
                        image={image}
                        url={url}
                      />
                    );
                  }
                )}
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

const ConditionalLink = ({ to, children, context, sendAction }) => {
  if (context == "splash" || /\/stations\//.test(to)) {
    return <a href={to}>{children}</a>;
  } else if (context == "quickmix") {
    return <a onClick={sendAction}>{children}</a>;
  } else {
    return (
      <Link to={to} data-turbolinks="false">
        {children}
      </Link>
    );
  }
};

const SearchResult = ({
  type,
  name,
  songtitle,
  image,
  url,
  context,
  action,
  artist_id,
  station_id,
}) => {
  let info;
  if (type == "Song") {
    info = (
      <div>
        <h3 className="mb-0 mt-0">{songtitle}</h3>
        <div>{name}</div>
      </div>
    );
  } else {
    info = <h3>{name}</h3>;
  }

  const sendAction = (event) => {
    action(event, { id: artist_id, station_id: station_id });
  };

  return (
    <div className="search-result" tabIndex="0">
      <ConditionalLink
        to={url}
        data-turbolinks="false"
        context={context}
        sendAction={sendAction}
      >
        <Grid container alignItems="center">
          <Grid item xs={3} md={2} className="image">
            {/*            <img src={image} className="w-100" />
             */}
            <CardArt image={image} />
          </Grid>
          <Grid item xs>
            <div className="left-text">{info}</div>
          </Grid>
          {/*
          <Grid item className="type">
            <div className="right-text">{type}</div>
          </Grid>
          */}
        </Grid>
      </ConditionalLink>
    </div>
  );
};

export default SearchBar;
